import { useMutation, useQueryClient } from "react-query";

import axios, { AxiosError } from "axios";

import { REACT_APP_STICK_SCHEDULER_SERVICE_ADDRESS } from "../modals/constants";
import { StickCalculationsJob } from "../models/StickCalculations";

export function usePutStickCalculationJob() {
  const queryClient = useQueryClient();
  return useMutation<string, AxiosError, StickCalculationsJob>(
    async (data: StickCalculationsJob) => {
      const response = await axios.put(
        `${REACT_APP_STICK_SCHEDULER_SERVICE_ADDRESS}/job`,
        data
      );
      if (response.status !== 200) {
        throw new Error("Error creating access token");
      }

      return response.data;
    },
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries("stickCalculationJobs");
      }
    }
  );
}
